import React, { useEffect, useRef, useState } from 'react'
import Loader from '../../../common/Loader';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { formatDateWithDateAndMonthName, getValueFromResource } from '../../../common/timeLiveFunction';
import { t } from "i18next";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Dropdown } from 'react-bootstrap';
import clsx from 'clsx';
import PriorityMenu from './PriorityMenu';
import ReactDatePicker from 'react-datepicker';
import { AddOrRemoveAccountProjectTaskTeam, AddTask, DeleteTask, GetAccountProjectTask, GetAccountProjectTaskTeam, GetAccountStatus, UpdateAccountProjectTaskField } from './BoardSlice';
import parse from 'html-react-parser';
import moment from 'moment';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { updateIsCanvasFrom } from '../MilestoneSlice';
import { updateAccountProjectTaskId } from '../TasksSlice';
import { ShowToast } from '../../../common/Toastr';
import BoardTeamMember from './BoardTeamMember';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import calendar from '../../../../src/assets/image/calendar.svg';
import comment from '../../../../src/assets/image/comment.svg';
import attachment from '../../../../src/assets/image/attachment.svg';
import taskName from '../../../../src/assets/image/TaskName.svg';
import assignee from '../../../../src/assets/image/assignee.svg';
import taskCoder from '../../../../src/assets/image/taskCoder.svg';
import './Board.css';

const rowStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    minHeight: 28,
    marginBottom: 8,
};

const labelStyle: React.CSSProperties = {
    fontSize: 12,
    color: '#6B7280',
    width: 65,
    minWidth: 65,
    flexShrink: 0,
    textAlign: 'left',
};

const inlineInputStyle: React.CSSProperties = {
    fontSize: 13,
    color: '#111827',
    fontWeight: 600,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    padding: 0,
    flex: 1,
    minWidth: 0,
    fontFamily: 'inherit',
};

const dateBadgeStyle: React.CSSProperties = {
    fontSize: 11,
    background: '#F3F4F6',
    border: '0.5px solid #E5E7EB',
    borderRadius: 6,
    padding: '3px 7px',
    color: '#111827',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    display: 'inline-block',
};

const priorityMenuStyle: React.CSSProperties = {
    position: 'absolute',
    top: 26,
    left: 0,
    background: '#FFFFFF',
    border: '0.5px solid #E5E7EB',
    borderRadius: 8,
    padding: 4,
    zIndex: 999,
    minWidth: 130,
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
};

const UpdatedBoard = (props: any) => {
    const { AccountProjectId, isAddTask, permission, showAdvance } = props;
    const { IsEditTask, IsAddTask, IsDeleteTask, } = permission
    const { ProjectCode, ProjectName, Status, StartDate, Deadline, ProjectBillingRateTypeId } = props.obj;
    const { isLoading } = useAppSelector((state) => state.board);
    const { isReload } = useAppSelector((state) => state.tasks);
    const { cultureInfoName } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fromValue = queryParams.get('from');
    const [renameTask, setRenameTask] = useState<any>(null);
    const [selectedDateTaskId, setSelectedDateTaskId] = useState<string | null>(null);
    const [addingTaskColumn, setAddingTaskColumn] = useState<any>(null);
    const [newTaskData, setNewTaskData] = useState<{
        code: string;
        title: string;
        assignee?: string;
        startDate?: Date | null;
        endDate?: Date | null;
        priority?: any;
        isBillable?: boolean;
    }>({
        code: '',
        title: '',
        assignee: '',
        startDate: null,
        endDate: null,
        priority: 'Medium',
        isBillable: false,
    });
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [showAssigneeMenu, setShowAssigneeMenu] = useState(false);
    const [showPriorityMenu, setShowPriorityMenu] = useState(false);
    const [status, setStatus] = useState([]);
    const [task, setTask] = useState<any[]>([]);
    const [prioritiesData, setPrioritiesData] = useState<any[]>([]);
    const [team, setTeam] = useState<any>([])
    const [addPriority, setAddPriority] = useState<any>({});
    const [employeeIds, setEmployeeIds] = useState([]);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const priorityColorCache = useRef<Record<string, string>>({});
    const [openPriorityTaskId, setOpenPriorityTaskId] = useState<string | null>(null);
    const [selectedAddTaskMembers, setSelectedAddTaskMembers] = useState<any[]>([]);
    const [showStartDatePicker, setShowStartDatePicker] = useState(false);
    const [showEndDatePicker, setShowEndDatePicker] = useState(false);

    useEffect(() => {
        const getStatus = async () => {
            const response = await dispatch(GetAccountStatus()).then((snap) => {
                const result = snap?.payload?.Data || [];
                setStatus(result);
            }).catch((error) => {
                console.log(error);
            })
        }
        getStatus();
    }, [])

    useEffect(() => {
        if (prioritiesData.length > 0 && !addPriority?.AccountPriorityId) {
            const mediumPriority = prioritiesData.find(p => p.Priority === 'Medium');
            if (mediumPriority) {
                setAddPriority(mediumPriority);
                setNewTaskData(prev => ({ ...prev, priority: 'Medium' }));
            }
        }
    }, [prioritiesData])

    const getProjectTasks = async () => {
        const response = await dispatch(GetAccountProjectTask({ AccountProjectId })).then((snap) => {
            const result = snap?.payload?.Data || [];
            setTask(result);
        }).catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        getProjectTasks();
    }, [isReload])

    useEffect(() => {
        if (addingTaskColumn !== null) {
            getTeamMembers(0);
            setSelectedAddTaskMembers([]);
            setEmployeeIds([]);
        }
    }, [addingTaskColumn]);

    const getPriorityColor = (priorityName: string): string => {
        const defaultColors: Record<string, string> = {
            Urgent: '#dc3545',
            High: '#ffc107',
            Medium: '#0d6efd',
            Low: '#6c757d',
        };

        if (defaultColors[priorityName]) {
            return defaultColors[priorityName];
        }

        if (priorityColorCache.current[priorityName]) {
            return priorityColorCache.current[priorityName];
        }

        const darkPalette = [
            '#2c3e50', // Midnight Blue
            '#8e44ad', // Wisteria Purple
            '#d35400', // Pumpkin/Dark Orange
            '#16a085', // Dark Teal
            '#27ae60', // Nephritis Green
            '#7f8c8d', // Dark Grey
            '#8B4513', // Saddle Brown
            '#483D8B', // Dark Slate Blue
            '#556B2F', // Dark Olive Green
            '#008B8B', // Dark Cyan
            '#800080', // Purple
            '#A52A2A', // Brown
            '#2F4F4F', // Dark Slate Gray
        ];

        let hash = 0;
        for (let i = 0; i < priorityName.length; i++) {
            hash = priorityName.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % darkPalette.length;
        const assignedColor = darkPalette[index];
        priorityColorCache.current[priorityName] = assignedColor;

        return assignedColor;
    };

    const getPriorityInfoById = (priorityId: any) => {
        const priority = prioritiesData.find(p => p.AccountPriorityId == priorityId || p.PriorityId == priorityId);
        return {
            name: priority ? priority.Priority : 'Medium',
            color: priority ? priority.color : '#0d6efd'
        };
    };

    const getPriorityData = async () => {
        const response = await fetchTimeliveAPI('api/Priority', `Get`, '', true);
        const json = await response?.json();
        // const colorMap: Record<string, string> = {
        //     Urgent: '#dc3545',
        //     High: '#ffc107',
        //     Medium: '#0d6efd',
        //     Low: '#6c757d',
        // };

        const options = json?.Data?.map((item: any) => ({
            ...item,
            color: getPriorityColor(item.Priority),//colorMap[item.Priority] || '#000000',
        }));
        setPrioritiesData(options || []);
    }

    useEffect(() => {
        getPriorityData();
    }, []);

    const UpdateTask = async (payload: any) => {
        const response = await dispatch(UpdateAccountProjectTaskField(payload)).then((snap) => {
            if (snap?.payload?.StatusCode === '200') {
                getProjectTasks();
                ShowToast('Success', snap?.payload.ResponseMessage, "success", "toast-top-right");
            } else {
                ShowToast('Error', snap?.payload?.title, "error", "toast-top-right");
            }
        }).catch((error) => {
            ShowToast('Error', error.ResponseMessage, "error", "toast-top-right");
            console.log(error);
        })
    }

    const onDragEnd = async (result: any) => {
        const { source, destination, draggableId } = result;
        if (!destination) return;

        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            return;
        }

        const taskId = parseInt(draggableId);
        const destStatusId = parseInt(destination.droppableId);
        const draggedTask = task.find((t: any) => t.AccountProjectTaskId === taskId);

        if (!draggedTask) {
            return;
        }

        const updatedTasks = task.map((t: any) => {
            if (t.AccountProjectTaskId === taskId) {
                return { ...t, TaskStatusId: destStatusId };
            }
            return t;
        });
        setTask(updatedTasks);
        const payload = {
            AccountProjectId: AccountProjectId,
            AccountProjectTaskId: taskId,
            FieldName: "TaskStatusId",
            FieldValue: destination.droppableId,
        };
        try {
            const response = await dispatch(UpdateAccountProjectTaskField(payload));

            if (response?.payload?.StatusCode === '200') {
                getProjectTasks();
                ShowToast('Success', response?.payload.ResponseMessage, "success", "toast-top-right");
            } else {
                setTask(task);
                ShowToast('Error', response?.payload?.title, "error", "toast-top-right");
            }
        } catch (error: any) {
            setTask(task);
            ShowToast('Error', error.ResponseMessage, "error", "toast-top-right");
            console.log(error);
        }
    };

    const handleRename = (id: any, key: any, name: any) => {
        setRenameTask({ id, title: name })
    }

    const handlePriorityChange = (taskId: string, priority: any) => {
        const payload = {
            AccountProjectId: AccountProjectId,
            AccountProjectTaskId: taskId,
            FieldName: "AccountPriorityId",
            FieldValue: priority?.AccountPriorityId.toString(),
        }
        UpdateTask(payload);
    }

    const handleAddTask = async (columnId: any) => {
        if (!newTaskData.title.trim()) {
            ShowToast('Error', 'Task Name is required!', "error", "toast-top-right");
            return;
        }
        let priorityId = addPriority?.AccountPriorityId;
        if (!priorityId) {
            const mediumPriority = prioritiesData.find(p => p.Priority === 'Medium');
            priorityId = mediumPriority?.AccountPriorityId;
        }
        const payload = {
            AccountProjectId: Number(AccountProjectId),
            ParentAccountProjectTaskId: null,
            TaskName: newTaskData.title,
            TaskDescription: '',
            AccountTaskTypeId: 0,
            Duration: 0,
            DurationUnit: "Hours",
            DeadlineDate: moment(newTaskData?.endDate || new Date()).format('YYYY-MM-DD'),
            CompletedPercent: 0,
            Completed: false,
            IsParentTask: false,
            IsForAllEmployees: false,
            AccountPriorityId: priorityId,//addPriority?.AccountPriorityId,
            TaskStatusId: columnId,
            AccountProjectMilestoneId: 0,
            IsReOpen: false,
            EstimatedCost: 0,
            EstimatedTimeSpent: 0,
            EstimatedTimeSpentUnit: "Hours",
            IsBillable: newTaskData?.isBillable || false,
            IsDisabled: false,
            IsForAllProjectTask: false,
            TaskCode: newTaskData?.code || '',
            EstimatedCurrencyId: 0,
            StartDate: moment(newTaskData?.startDate || new Date()).format('YYYY-MM-DD'),
            SystemBillingRateTypeId: 4,
            BillingRate: 0,
            BillingStartDate: moment(newTaskData?.startDate || new Date()).format('YYYY-MM-DD'),
            BillingEndDate: moment(newTaskData?.endDate || new Date()).format('YYYY-MM-DD'),
            AccountWorkTypeId: 0,
            EmployeeRate: 0,
            BillingRateCurrencyId: 0,
            EmployeeRateCurrencyId: 0,
            SystemDurationUnitID: 3,
            AccountEmployeeIdsForTeam: employeeIds.join(',')
        }
        await dispatch(AddTask(payload)).then((snap) => {
            if (snap?.payload?.StatusCode === '201') {
                getProjectTasks();
                setNewTaskData((previous) => ({
                    code: '',
                    title: '',
                    assignee: '',
                    dueDate: null,
                    priority: 'Medium',
                }))
                setAddingTaskColumn(null);
                setEmployeeIds([])
                setSelectedAddTaskMembers([]);
                ShowToast('Success', snap?.payload.ResponseMessage, "success", "toast-top-right");
            } else {
                ShowToast('Error', snap?.payload?.title, "error", "toast-top-right");
            }
        }).catch((error) => {
            ShowToast('Error', error.ResponseMessage, "error", "toast-top-right");
            console.log(error);
        })

    };

    const handleRenameSave = () => {
        if (renameTask && renameTask.title.trim()) {
            const payload = {
                AccountProjectId: AccountProjectId,
                AccountProjectTaskId: renameTask?.id,
                FieldName: "TaskName",
                FieldValue: renameTask?.title,

            }
            UpdateTask(payload);
        }
        setRenameTask(null);
    }

    const handleDateChange = (taskId: string, date: Date | null) => {
        const payload = {
            AccountProjectId: AccountProjectId,
            AccountProjectTaskId: taskId,
            FieldName: "DeadlineDate",
            FieldValue: moment(date).format('YYYY-MM-DD'),
        }
        UpdateTask(payload);
        setSelectedDateTaskId(null)
    };

    const getPriorityNameById = (priorityId: string) => {
        const priority = prioritiesData.find(p => p.AccountPriorityId === priorityId || p.PriorityId === priorityId);
        return priority ? priority.Priority : 'Medium';
    };

    const getTeamMembers = async (taskId: any) => {
        try {
            const snap = await dispatch(GetAccountProjectTaskTeam({ AccountProjectId, taskId }))
            const result = snap?.payload?.Data || []
            const sorted = [...result].sort((a, b) => (b.IncludeTeam ? 1 : 0) - (a.IncludeTeam ? 1 : 0))
            setTeam(sorted)
        } catch (error) {
            console.log(error)
        }
    }

    const AddRemoveTeam = async (taskId: any, member: any) => {
        const payload = {
            // AccountId: AccountId,
            AccountEmployeeId: member?.AccountEmployeeId,
            AccountProjectTaskId: taskId,
            IsTeamAdd: member?.IncludeTeam,

        }
        await dispatch(AddOrRemoveAccountProjectTaskTeam(payload)).then((snap) => {
            if (snap?.payload?.StatusCode === '200') {
                getProjectTasks();
                ShowToast('Success', snap?.payload.ResponseMessage, "success", "toast-top-right");
            } else {
                ShowToast('Error', snap?.payload?.title, "error", "toast-top-right");
            }
        }).catch((error) => {
            ShowToast('Error', error.ResponseMessage, "error", "toast-top-right");
            console.log(error);
        })
    }

    const handleDeleteTask = async (taskId: any) => {
        const payload = {
            AccountProjectId,
            AccountProjectTaskId: taskId
        };

        try {
            const result = await ShowSwalWithConfirmation('Are you sure you want to delete this record?', "");

            if (!result) return;

            const snap = await dispatch(DeleteTask(payload));

            if (snap?.payload?.StatusCode === '200') {
                await getProjectTasks();
                ShowToast('Success', snap?.payload?.ResponseMessage, "success", "toast-top-right");
            } else {
                ShowToast('Error', snap?.payload?.title, "error", "toast-top-right");
            }

        } catch (error: any) {
            ShowToast('Error', error?.ResponseMessage, "error", "toast-top-right");
            console.error(error);
        }
    };

    const resetAddTaskForm = () => {
        setAddingTaskColumn(null);
        setNewTaskData({ code: '', title: '', assignee: '', startDate: null, endDate: null, priority: 'Medium', isBillable: false });
        setShowAssigneeMenu(false);
        setShowStartDatePicker(false);
        setShowEndDatePicker(false);
        setShowPriorityMenu(false);
        setSelectedAddTaskMembers([]);
        setEmployeeIds([]);
        const mediumPriority = prioritiesData.find(p => p.Priority === 'Medium');
        setAddPriority(mediumPriority || {});
    };

    const getAvatarColor = (name: string) => {
        if (!name) return '#c084fc';
        const colors = ['#c084fc', '#f87171', '#60a5fa', '#34d399', '#fbbf24', '#a78bfa', '#f472b6'];
        let hash = 0;
        for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
        return colors[Math.abs(hash) % colors.length];
    };

    const getInitials = (name: string) => {
        if (!name) return '?';
        const parts = name.trim().split(' ');
        return parts.length >= 2 ? `${parts[0][0]}${parts[1][0]}`.toUpperCase() : name.substring(0, 2).toUpperCase();
    };

    const scrollableColumnStyles = {
        column: {
            minWidth: '310px',
            maxWidth: '340px',
            flexBasis: '33%',
            backgroundColor: '#F7F8F9',
            border: '1px solid #DEE2E6',
            borderRadius: '10px',
            padding: '0px 0.75rem 0.75rem',
            display: 'flex',
            flexDirection: 'column' as const,
            maxHeight: '600px',
            height: '600px',
            overflowY: 'auto' as const,
            overflowX: 'hidden' as const,
            position: 'relative' as const
        },
        taskContainer: {
            flex: 1,
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowAssigneeMenu(false);
            }
        };
        if (showAssigneeMenu) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showAssigneeMenu])

    const navigateToAccountProjectTaskSummary = (obj: any) => {
        localStorage.setItem('objTask', JSON.stringify(obj));
        if (fromValue === 'projectTemplate') {
            navigate(`/accountprojecttasksummary/${obj.AccountProjectId}/${obj.AccountProjectTaskId}?from=projectTemplateTask`);
        } else {
            navigate(`/accountprojecttasksummary/${obj.AccountProjectId}/${obj.AccountProjectTaskId}`);
        }
    }

    const getStatusStyle = (statusName: string) => {
        const statusColors: Record<string, { bg: string; dot: string }> = {
            Started: {
                bg: '#0C66E40D',
                dot: '#0C66E4',
            },
            OnHold: {
                bg: '#67266D0D',
                dot: '#67266D',
            },
            "In Progress": {
                bg: '#FF6D000D',
                dot: '#FF6D00',
            },
            Completed: {
                bg: '#0089780D',
                dot: '#008978',
            },
        };

        return (
            statusColors[statusName] || {
                bg: '#F1F3F5',
                dot: '#6C757D',
            }
        );
    };

    return (
        <div>
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                <div className='card-Report-body py-3 mt-3'>
                    <DragDropContext onDragEnd={(resut) => {
                        if (!IsEditTask) return;
                        onDragEnd(resut)
                    }}>
                        <div className="d-flex gap-3"
                            style={{
                                overflowX: 'auto',
                                overflowY: 'hidden',
                                flexWrap: 'nowrap',
                                paddingBottom: '10px'
                            }}
                        >
                            {status?.map((status: any, index: any) => {
                                const key = status?.AccountStatusId;
                                const statusStyle = getStatusStyle(status?.Status);
                                return (
                                    <Droppable droppableId={status?.AccountStatusId?.toString()} key={status?.AccountStatusId}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className={`rounded-lg board-column`}
                                                style={scrollableColumnStyles.column}
                                            >
                                                <div
                                                    className="d-flex align-items-center justify-content-between rounded-md my-2"
                                                    style={{
                                                        background: `linear-gradient(${statusStyle.bg}, ${statusStyle.bg}), #F7F8F9`,
                                                        backgroundBlendMode: 'normal',
                                                        padding: '8px 12px 8px 8px',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: statusStyle.dot, display: 'inline-block' }} />
                                                        <h4 className="fs-5 mb-0" style={{ color: '#181c32', lineHeight: '22px' }} >
                                                            {status?.Status}
                                                        </h4>
                                                    </div>
                                                    {isAddTask && (<div>
                                                        <i className="bi bi-plus-lg fw-bold fs-5 iconColor cursor-pointer" onClick={() => setAddingTaskColumn(key)} ></i>
                                                    </div>)}
                                                </div>

                                                {addingTaskColumn === key && (
                                                    <div
                                                        style={{
                                                            background: '#fff',
                                                            border: '1.5px solid #4A90D9',
                                                            borderRadius: '10px',
                                                            padding: '14px',
                                                            marginBottom: '10px',
                                                            fontFamily: 'inherit',
                                                        }}
                                                    >
                                                        <p style={{ fontSize: 13, fontWeight: 600, color: '#181c32', margin: '0 0 12px' }}>
                                                            {ProjectName || 'New Task'}
                                                        </p>

                                                        <div style={rowStyle}>
                                                            <span style={{ width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                <img
                                                                    src={taskCoder}
                                                                    width={12}
                                                                    height={12}
                                                                    data-tooltip-place="top"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content={getValueFromResource('Task Code', dispatch, t)}
                                                                />
                                                            </span>
                                                            <span style={labelStyle}>{getValueFromResource('Task Code', dispatch, t)}</span>
                                                            <input
                                                                type="text"
                                                                autoFocus
                                                                placeholder="Task Code"
                                                                value={newTaskData.code}
                                                                onChange={(e) => setNewTaskData(prev => ({ ...prev, code: e.target.value }))}
                                                                style={inlineInputStyle}
                                                            />
                                                        </div>

                                                        <div style={rowStyle}>
                                                            <span style={{ width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                <img
                                                                    src={taskName}
                                                                    width={15}
                                                                    height={15}
                                                                    data-tooltip-place="top"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content={getValueFromResource('Task Name', dispatch, t)}
                                                                />
                                                            </span>
                                                            <span style={labelStyle}>{getValueFromResource('Task Name', dispatch, t)}</span>
                                                            <input
                                                                type="text"
                                                                autoFocus
                                                                placeholder="Enter task name..."
                                                                value={newTaskData.title}
                                                                onChange={(e) => setNewTaskData(prev => ({ ...prev, title: e.target.value }))}
                                                                style={inlineInputStyle}
                                                            />
                                                        </div>

                                                        <div style={rowStyle}>
                                                            <span style={{ width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                <img
                                                                    src={assignee}
                                                                    width={20}
                                                                    height={20}
                                                                    data-tooltip-place="top"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content={getValueFromResource('Assignee', dispatch, t)}
                                                                />
                                                            </span>
                                                            <span style={labelStyle}>{getValueFromResource('Assignee', dispatch, t)}</span>
                                                            <div style={{ display: 'flex', alignItems: 'center', flex: 1, position: 'relative' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    {selectedAddTaskMembers.slice(0, 5).map((m: any, idx: number) => (
                                                                        <div
                                                                            key={m.AccountEmployeeId}
                                                                            title={m.Name}
                                                                            style={{
                                                                                width: 24, height: 24, borderRadius: '50%',
                                                                                background: getAvatarColor(m.Name),
                                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                                fontSize: 10, fontWeight: 600, color: '#fff',
                                                                                border: '2px solid #fff',
                                                                                marginLeft: idx === 0 ? 0 : -6,
                                                                                zIndex: 5 - idx,
                                                                                position: 'relative',
                                                                            }}
                                                                        >
                                                                            {getInitials(m.Name)}
                                                                        </div>
                                                                    ))}
                                                                    {selectedAddTaskMembers.length > 5 && (
                                                                        <div
                                                                            title={selectedAddTaskMembers.slice(5).map((m: any) => m.Name).join(', ')}
                                                                            style={{
                                                                                width: 24, height: 24, borderRadius: '50%',
                                                                                background: '#E5E7EB',
                                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                                fontSize: 9, fontWeight: 700, color: '#374151',
                                                                                border: '2px solid #fff',
                                                                                marginLeft: -6,
                                                                                zIndex: 0,
                                                                                position: 'relative',
                                                                                flexShrink: 0,
                                                                            }}
                                                                        >
                                                                            +{selectedAddTaskMembers.length - 5}
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {selectedAddTaskMembers.length === 0 && (
                                                                    <span style={{ fontSize: 12, color: '#9CA3AF', marginLeft: 4 }}>{getValueFromResource('Assignee', dispatch, t)}</span>
                                                                )}

                                                                <Dropdown
                                                                    show={showAssigneeMenu}
                                                                    onToggle={(isOpen) => setShowAssigneeMenu(isOpen)}
                                                                    align="start"
                                                                    autoClose="outside"
                                                                    style={{ marginLeft: 6 }}
                                                                >
                                                                    <Dropdown.Toggle as="div" className="cursor-pointer">
                                                                        <div style={{
                                                                            width: 24, height: 24, borderRadius: '50%',
                                                                            border: '1.5px dashed #9CA3AF',
                                                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                            background: '#F9FAFB', cursor: 'pointer',
                                                                            flexShrink: 0,
                                                                        }}>
                                                                            <i className="bi bi-plus" style={{ fontSize: 12, color: '#6B7280' }}></i>
                                                                        </div>
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu
                                                                        className="menu menu-sub menu-sub-dropdown menu-column px-2 py-2 fs-7 w-200px"
                                                                        style={{ position: 'fixed', zIndex: 9999 }} 
                                                                        popperConfig={{
                                                                            strategy: 'fixed',
                                                                            modifiers: [
                                                                                {
                                                                                    name: 'preventOverflow',
                                                                                    options: { boundary: 'viewport', padding: 8 },
                                                                                },
                                                                            ],
                                                                        }}
                                                                    >
                                                                        <BoardTeamMember
                                                                            isAddingTask={true}
                                                                            AccountProjectId={AccountProjectId}
                                                                            resetTrigger={addingTaskColumn}
                                                                            isOpen={showAssigneeMenu}
                                                                            team={team}
                                                                            selectedEmployeeIds={employeeIds}
                                                                            onSelectedMember={(ids: any) => {
                                                                                setEmployeeIds(ids);
                                                                                const selected = team.filter((m: any) => ids.includes(m.AccountEmployeeId));
                                                                                setSelectedAddTaskMembers(selected);
                                                                            }}
                                                                        />
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>

                                                        <div style={rowStyle}>
                                                            <span style={{ width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                                <img
                                                                    src={calendar}
                                                                    width={12}
                                                                    height={12}
                                                                    data-tooltip-place="top"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content={getValueFromResource('Duration', dispatch, t)}
                                                                />
                                                            </span>
                                                            <span style={labelStyle}>{getValueFromResource('Date', dispatch, t)}</span>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, flexWrap: 'nowrap' }}>
                                                                <div style={{ position: 'relative' }}>
                                                                    <ReactDatePicker
                                                                        selected={newTaskData.startDate}
                                                                        onChange={(date) => {
                                                                            setNewTaskData(prev => ({ ...prev, startDate: date }));
                                                                            setShowStartDatePicker(false);
                                                                        }}
                                                                        onClickOutside={() => setShowStartDatePicker(false)}
                                                                        open={showStartDatePicker}
                                                                        onInputClick={() => setShowStartDatePicker(true)}
                                                                        popperProps={{ positionFixed: true }}
                                                                        popperPlacement="bottom-start"
                                                                        customInput={
                                                                            <span
                                                                                onClick={() => setShowStartDatePicker(true)}
                                                                                style={dateBadgeStyle}
                                                                            >
                                                                                {newTaskData.startDate ? formatDateWithDateAndMonthName(newTaskData.startDate, cultureInfoName.toString()) : getValueFromResource('Start date', dispatch, t)}
                                                                            </span>
                                                                        }
                                                                    />
                                                                </div>
                                                                <span style={{ fontSize: 11, color: '#9CA3AF' }}>{getValueFromResource('to', dispatch, t)}</span>
                                                                <div style={{ position: 'relative' }}>
                                                                    <ReactDatePicker
                                                                        selected={newTaskData.endDate}
                                                                        onChange={(date) => {
                                                                            setNewTaskData(prev => ({ ...prev, endDate: date }));
                                                                            setShowEndDatePicker(false);
                                                                        }}
                                                                        onClickOutside={() => setShowEndDatePicker(false)}
                                                                        open={showEndDatePicker}
                                                                        onInputClick={() => setShowEndDatePicker(true)}
                                                                        popperProps={{ positionFixed: true }}
                                                                        popperPlacement="bottom-start"
                                                                        customInput={
                                                                            <span
                                                                                onClick={() => setShowEndDatePicker(true)}
                                                                                style={dateBadgeStyle}
                                                                            >
                                                                                {newTaskData.endDate ? formatDateWithDateAndMonthName(newTaskData.endDate, cultureInfoName.toString()) : getValueFromResource('End date', dispatch, t)}
                                                                            </span>
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div style={{ height: '0.5px', background: '#E5E7EB', margin: '10px 0' }} />

                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 12, flexWrap: 'nowrap' }}>
                                                            <div style={{ position: 'relative' }}>
                                                                <div
                                                                    style={{ display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer' }}
                                                                    onClick={() => setShowPriorityMenu(prev => !prev)}
                                                                >
                                                                    <i
                                                                        className="ki-solid ki-flag fs-4 cursor-pointer"
                                                                        data-tooltip-place="top"
                                                                        data-tooltip-id="tooltip-Description"
                                                                        data-tooltip-content={getValueFromResource('Priority', dispatch, t)}
                                                                        style={{ fontSize: 14, color: addPriority?.color || '#0d6efd' }}
                                                                    ></i>
                                                                    <span style={{ fontSize: 12, fontWeight: 500, color: addPriority?.color || '#0d6efd' }}>
                                                                        {addPriority?.Priority || 'Medium'}
                                                                    </span>
                                                                </div>
                                                                {showPriorityMenu && (
                                                                    <div style={priorityMenuStyle}>
                                                                        {prioritiesData.map((p: any) => (
                                                                            <div
                                                                                key={p.AccountPriorityId}
                                                                                style={{
                                                                                    display: 'flex', alignItems: 'center', gap: 8,
                                                                                    padding: '7px 10px', borderRadius: 6, cursor: 'pointer',
                                                                                    background: addPriority?.AccountPriorityId === p.AccountPriorityId ? '#F3F4F6' : 'transparent',
                                                                                }}
                                                                                onMouseEnter={e => (e.currentTarget.style.background = '#F3F4F6')}
                                                                                onMouseLeave={e => (e.currentTarget.style.background = addPriority?.AccountPriorityId === p.AccountPriorityId ? '#F3F4F6' : 'transparent')}
                                                                                onClick={() => {
                                                                                    setAddPriority(p);
                                                                                    setNewTaskData(prev => ({ ...prev, priority: p.Priority }));
                                                                                    setShowPriorityMenu(false);
                                                                                }}
                                                                            >
                                                                                <i className="ki-solid ki-flag" style={{ fontSize: 13, color: p.color }}></i>
                                                                                <span style={{ fontSize: 13, color: p.color, fontWeight: 500 }}>{p.Priority}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: 7, userSelect: 'none', flexShrink: 0 }}>
                                                                <div
                                                                    onClick={() => setNewTaskData(prev => ({ ...prev, isBillable: !prev.isBillable }))}
                                                                    style={{
                                                                        width: 34, height: 18, borderRadius: 9,
                                                                        background: newTaskData.isBillable ? '#3B82F6' : '#D1D5DB',
                                                                        position: 'relative', cursor: 'pointer', transition: 'background 0.2s', flexShrink: 0,
                                                                    }}
                                                                >
                                                                    <div style={{
                                                                        position: 'absolute', top: 2,
                                                                        left: newTaskData.isBillable ? 16 : 2,
                                                                        width: 14, height: 14, borderRadius: '50%',
                                                                        background: '#fff', transition: 'left 0.2s',
                                                                    }} />
                                                                </div>
                                                                <span style={{ fontSize: 12, fontWeight: 500, color: '#374151' }}>{getValueFromResource('Billable', dispatch, t)}</span>
                                                            </label>
                                                        </div>
                                                        <div style={{ height: '0.5px', background: '#E5E7EB', margin: '10px 0' }} />
                                                        <div className="d-flex gap-2">
                                                            <button
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => handleAddTask(key)}
                                                            >
                                                                {getValueFromResource('Save', dispatch, t)}
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm fs-7"
                                                                onClick={resetAddTaskForm}
                                                            > 
                                                                {getValueFromResource('Cancel', dispatch, t)}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                <div style={scrollableColumnStyles.taskContainer}>
                                                    {task?.filter((item: any, ind: any) => item?.TaskStatusId === status?.AccountStatusId).map((task: any, index: any) => {
                                                        const priorityInfo = getPriorityInfoById(task.AccountPriorityId);
                                                        return (
                                                            <Draggable
                                                                key={task.AccountProjectTaskId}
                                                                draggableId={task.AccountProjectTaskId.toString()}
                                                                index={index}
                                                                isDragDisabled={!IsEditTask}
                                                            >
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            ...provided.draggableProps.style,
                                                                            borderRadius: '5px',
                                                                            marginTop: '15px',
                                                                            marginBottom: '15px'
                                                                        }}
                                                                        className="bg-white rounded-lg p-3 mb-2 shadow-sm hover:shadow-md transition cursor-pointer active:cursor-pointer"
                                                                    >
                                                                        <div className="d-flex justify-content-between">
                                                                            <div
                                                                                className="flex-grow-1"
                                                                                style={{ minWidth: 0 }}
                                                                            >
                                                                                {/* <span className='text-gray-600 fs-7' style={{ lineHeight: 1 }}>{ProjectName} &gt; {task?.ParentTaskNamesList?.map((item: any)=>(
                                                                                    item?.value
                                                                                ))}</span> */}
                                                                                <span
                                                                                    className='text-gray-600 fs-7'
                                                                                    style={{
                                                                                        lineHeight: '1.4',
                                                                                        display: '-webkit-box',
                                                                                        WebkitLineClamp: 2,
                                                                                        WebkitBoxOrient: 'vertical',
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        wordBreak: 'break-word',
                                                                                    }}
                                                                                >
                                                                                    {ProjectName}
                                                                                    {task?.ParentTaskNamesList?.length > 0 && (
                                                                                        <>
                                                                                            {task.ParentTaskNamesList.map((item: any, idx: number) => (
                                                                                                <span key={idx}>
                                                                                                    {' > '}
                                                                                                    {item?.value}
                                                                                                </span>
                                                                                            ))}
                                                                                        </>
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                            <Dropdown
                                                                                className={clsx('cursor-pointer symbol board-icon-hover flex-shrink-0')}
                                                                                data-kt-menu-attach='parent'
                                                                                data-kt-menu-placement='bottom-end'
                                                                            >
                                                                                <Dropdown.Toggle
                                                                                    variant="transparent"
                                                                                    className="btn btn-icon btn-sm ms-0" //btn-active-light-dark - this is for hover bg-gray color
                                                                                    data-tooltip-id="tooltip-Description"
                                                                                    data-tooltip-content={getValueFromResource('More', dispatch, t)}
                                                                                    data-tooltip-place="top"
                                                                                >
                                                                                    <i className="bi bi-three-dots fs-7 iconColor"></i>
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                                                    {IsEditTask && <div className='menu-hover-bg-sec'>
                                                                                        <Dropdown.Item
                                                                                            id="kt_OffCanvas"
                                                                                            className="menu-item me-lg-0"
                                                                                            onClick={() => {
                                                                                                dispatch(updateIsCanvasFrom(getValueFromResource('Task', dispatch, t)));
                                                                                                dispatch(updateAccountProjectTaskId(task.AccountProjectTaskId))
                                                                                            }}
                                                                                        >
                                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                                                    <span className="path1"></span>
                                                                                                    <span className="path2"></span>
                                                                                                </i>
                                                                                            </span>
                                                                                            <span className="menu-title custom-menu-fontsize">
                                                                                                {getValueFromResource('Edit', dispatch, t)}
                                                                                            </span>
                                                                                        </Dropdown.Item>
                                                                                    </div>}
                                                                                    <div className='separator mb-1 mt-1 opacity-75'></div>
                                                                                    <div className='menu-hover-bg-sec'>
                                                                                        <Dropdown.Item
                                                                                            className="menu-item me-lg-0"
                                                                                            onClick={() => {
                                                                                                navigateToAccountProjectTaskSummary({
                                                                                                    "AccountProjectId": AccountProjectId,
                                                                                                    "AccountProjectTaskId": task.AccountProjectTaskId,
                                                                                                    "ProjectCode": ProjectCode,
                                                                                                    "ProjectName": ProjectName,
                                                                                                    "Status": Status,
                                                                                                    "StartDate": StartDate,
                                                                                                    "Deadline": Deadline,
                                                                                                    "ProjectBillingRateTypeId": ProjectBillingRateTypeId
                                                                                                });
                                                                                            }}
                                                                                        >
                                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                                <i className="bi bi-file-earmark-text fs-4 iconColor">
                                                                                                    <span className="path1"></span>
                                                                                                    <span className="path2"></span>
                                                                                                </i>
                                                                                            </span>
                                                                                            <span className="menu-title custom-menu-fontsize">
                                                                                                {getValueFromResource('View Task', dispatch, t)}
                                                                                            </span>
                                                                                        </Dropdown.Item>
                                                                                    </div>
                                                                                    <div className='separator mb-1 mt-1 opacity-75'></div>
                                                                                    {IsDeleteTask && <div className='menu-hover-bg-danger'>
                                                                                        <Dropdown.Item
                                                                                            className="menu-item me-lg-0"
                                                                                            onClick={() => handleDeleteTask(task.AccountProjectTaskId)}
                                                                                        >
                                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                                                    <span className="path1"></span>
                                                                                                    <span className="path2"></span>
                                                                                                </i>
                                                                                            </span>
                                                                                            <span className="menu-title delete-menu custom-menu-fontsize">
                                                                                                {getValueFromResource('Delete', dispatch, t)}
                                                                                            </span>
                                                                                        </Dropdown.Item>
                                                                                    </div>}
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                                                            <div className="d-flex align-items-center gap-1">
                                                                                <span className="px-2 py-1" style={{ background: "#3A3A3A", border: '1px solid #3A3A3A', color: "#fff", borderRadius: "6px", fontSize: "11px", fontWeight: 500 }}>
                                                                                    {task?.TaskCode ? `${getValueFromResource('Task', dispatch, t)}-${task?.TaskCode}` : 'No Code'}
                                                                                </span>
                                                                                {task?.IsParentTask && (
                                                                                    <span className="px-2 py-1" style={{ background: "#F8EEF9", border: '1px solid #A54FA5', color: "#A54FA5", borderRadius: "6px", fontSize: "11px", fontWeight: 500 }} >
                                                                                       {getValueFromResource('Parent Task', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                            </div>

                                                                            <div className="d-flex align-items-center gap-1 px-3 py-2" style={{ background: task?.IsBillable ? "#F3FAF8" : '#EE38530D', borderRadius: "10px" }} >
                                                                                <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: task?.IsBillable ? "#008978" : "#DC3545", display: "inline-block" }} />
                                                                                <span style={{ color: task?.IsBillable ? "#008978" : "#DC3545", fontSize: "11px", fontWeight: 500 }} >
                                                                                    {task?.IsBillable ? `${getValueFromResource('Billable', dispatch, t)}` : `${getValueFromResource('Non Billable', dispatch, t)}`}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="my-4">
                                                                            <h4
                                                                                className="fs-6"
                                                                                style={{
                                                                                    color: '#181c32',
                                                                                    lineHeight: '1.4',
                                                                                    display: '-webkit-box',
                                                                                    WebkitLineClamp: 2,
                                                                                    WebkitBoxOrient: 'vertical',
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    wordBreak: 'break-word',
                                                                                    margin: 0,
                                                                                }}
                                                                            >
                                                                                {task?.TaskName}
                                                                            </h4>
                                                                        </div>
                                                                        {showAdvance && (
                                                                            // <p className="fs-7 mb-3" style={{ color: '#7B8BA6', lineHeight: '1.5' }}>
                                                                            //     {task?.TaskDescription}
                                                                            // </p>
                                                                            <p className="fs-7 mb-3" style={{
                                                                                color: '#7B8BA6',
                                                                                lineHeight: '1.5',
                                                                                display: '-webkit-box',
                                                                                WebkitLineClamp: 5,
                                                                                WebkitBoxOrient: 'vertical',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                wordBreak: 'break-word',
                                                                            }}>
                                                                                {task?.TaskDescription}
                                                                            </p>
                                                                        )}
                                                                       
                                                                        <div className="mt-2 mb-3">
                                                                            {(() => {
                                                                                const today = moment().startOf('day');
                                                                                const deadline = moment(task?.DeadlineDate).startOf('day');
                                                                                const daysLeft = deadline.diff(today, 'days');
                                                                                const daysToShow = daysLeft < 0 ? 0 : daysLeft;
                                                                                const showDueDays = daysLeft <= 10;
                                                                                const totalCost = (task?.CalculatedTimeEntryCost ?? 0) + (task?.CalculatedExpenseEntryCost ?? 0);

                                                                                return (
                                                                                    <>
                                                                                        <div className="d-flex align-items-center justify-content-between gap-1 mb-1">
                                                                                            <div className="d-flex align-items-center gap-1" style={{ minWidth: 0 }}>
                                                                                                <img
                                                                                                    src={calendar}
                                                                                                    data-tooltip-place="top"
                                                                                                    data-tooltip-id="tooltip-Description"
                                                                                                    data-tooltip-content={getValueFromResource('Duration', dispatch, t)}
                                                                                                />
                                                                                                <span className='fs-7' style={{ color: '#7B8BA6', fontWeight: 400, whiteSpace: 'nowrap' }}>
                                                                                                    {formatDateWithDateAndMonthName(task?.StartDate, cultureInfoName.toString())} - {formatDateWithDateAndMonthName(task?.DeadlineDate, cultureInfoName.toString())}
                                                                                                </span>
                                                                                            </div>
                                                                                            {showAdvance && !showDueDays && (
                                                                                                <div className="d-flex align-items-center gap-1 flex-shrink-0">
                                                                                                    {/* <i className="bi bi-currency-dollar fs-6" style={{ color: task?.IsBillable ? '#008978' : '#DC3545' }}></i> */}
                                                                                                    <span className="fs-7 fw-semibold" style={{ color: task?.IsBillable ? '#008978' : '#DC3545' }}>
                                                                                                        {task?.CurrencyCode}
                                                                                                    </span>
                                                                                                    <span className="fs-7 fw-semibold" style={{ color: task?.IsBillable ? '#008978' : '#DC3545' }}>
                                                                                                        {totalCost}
                                                                                                    </span>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                        {showAdvance && showDueDays && (
                                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                                <span className="fs-7" style={{ color: task?.IsOverdue ? '#DC3545' :'#7B8BA6' }}>
                                                                                                    {task?.DueDateLabel ? `(${task.DueDateLabel})` : null}
                                                                                                   {/* {`(${getValueFromResource(`Due Days`, dispatch, t)} ${daysToShow})`} */}
                                                                                                </span>
                                                                                                <div className="d-flex align-items-center gap-1">
                                                                                                    {/* <i className="bi bi-currency-dollar fs-6" style={{ color: task?.IsBillable ? '#008978' : '#DC3545' }}></i> */}
                                                                                                    <span className="fs-7 fw-semibold" style={{ color: task?.IsBillable ? '#008978' : '#DC3545' }}>
                                                                                                        {task?.CurrencyCode}
                                                                                                    </span>
                                                                                                    <span className="fs-7 fw-semibold" style={{ color: task?.IsBillable ? '#008978' : '#DC3545' }}>
                                                                                                        {totalCost}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                        {showAdvance && (
                                                                            <div className="mb-3 p-2" style={{ backgroundColor: '#F7F8F9', borderRadius: '8px' }}>
                                                                                <div className="d-flex align-items-start justify-content-between gap-2" style={{ flexWrap: 'nowrap' }}>
                                                                                    {/* <div className="d-flex flex-column" style={{ flex: 1 }}>
                                                                                        <span className="fs-7 fw-semibold mb-1" style={{ color: '#181c32' }}>{getValueFromResource('Progress', dispatch, t)}</span>
                                                                                        <div className="d-flex align-items-center gap-2">
                                                                                            <div style={{ flex: 1, backgroundColor: '#DEE2E6', borderRadius: '4px', height: '8px' }}>
                                                                                                <div
                                                                                                    style={{
                                                                                                        // width: `${task?.ProgressPercentage}`,
                                                                                                        width: `${Math.min(parseFloat(task?.ProgressPercentage || 0), 100)}%`,
                                                                                                        backgroundColor: '#008978',
                                                                                                        borderRadius: '4px',
                                                                                                        height: '8px',
                                                                                                        transition: 'width 0.3s ease'
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                            <span className="fs-7 fw-semibold" style={{ color: '#181c32', minWidth: '28px' }}>
                                                                                                {`${task?.ProgressPercentage}`}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div> */}
                                                                                    {(() => {
                                                                                        const progress = parseFloat(task?.ProgressPercentage || '0');
                                                                                        const isOverLimit = progress > 100;
                                                                                        return (
                                                                                            <div className="d-flex flex-column" style={{ flex: 1 }}>
                                                                                                <span className="fs-7 fw-semibold mb-1" style={{ color: '#181c32' }}>{getValueFromResource('Progress', dispatch, t)}</span>
                                                                                                <div className="d-flex align-items-center gap-2">
                                                                                                    <div style={{ flex: 1, backgroundColor: '#DEE2E6', borderRadius: '4px', height: '8px' }}>
                                                                                                        <div
                                                                                                            style={{
                                                                                                                width: `${Math.min(progress, 100)}%`,
                                                                                                                backgroundColor: isOverLimit ? '#DC3545' : '#008978',
                                                                                                                borderRadius: '4px',
                                                                                                                height: '8px',
                                                                                                                transition: 'width 0.3s ease, background-color 0.3s ease'
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <span className="fs-7 fw-semibold" style={{ color: isOverLimit ? '#DC3545' : '#181c32', minWidth: '28px' }}>
                                                                                                        {`${task?.ProgressPercentage}`}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    })()}
                                                                                    <div className="d-flex flex-column" style={{ width: 'auto', flexShrink: 0, minWidth: '80px' }}>
                                                                                        <span className="fs-7 fw-semibold mb-1" style={{ color: '#181c32' }}>{getValueFromResource('Time', dispatch, t)}</span>
                                                                                        <div className="d-flex align-items-center gap-1">
                                                                                            <i className="bi bi-clock fs-7" style={{ color: '#181c32' }}></i>
                                                                                            <span className="fs-7 fw-600" style={{ color: '#181c32' }}>
                                                                                                {task?.TimeEntryHours}h / {task?.TotalTime}h
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        <div className="boardSeparator my-2"></div>
                                                                        <div
                                                                            className="d-flex align-items-center justify-content-between"
                                                                            style={{ padding: '11px 12px 11px 0' }}
                                                                        >
                                                                            <div className="d-flex align-items-center gap-3">
                                                                                <div className="d-flex align-items-center gap-1">
                                                                                    <img
                                                                                        src={comment}
                                                                                        alt="comment"
                                                                                        data-tooltip-place="top"
                                                                                        data-tooltip-id="tooltip-Description"
                                                                                        data-tooltip-content={getValueFromResource('Comments', dispatch, t)}
                                                                                    />
                                                                                    <span className="fs-7">{task?.TotalComments}</span>
                                                                                </div>

                                                                                <div className="d-flex align-items-center gap-1">
                                                                                    <img
                                                                                        src={attachment}
                                                                                        alt="attachment"
                                                                                        data-tooltip-place="top"
                                                                                        data-tooltip-id="tooltip-Description"
                                                                                        data-tooltip-content={getValueFromResource('Attachments', dispatch, t)}
                                                                                    />
                                                                                    <span className="fs-7">{task?.TotalAttachments}</span>
                                                                                </div>

                                                                                <div className="d-flex align-items-center gap-1">
                                                                                    <i
                                                                                        className="ki-solid ki-flag fs-4 cursor-pointer"
                                                                                        style={{ color: priorityInfo?.color }}
                                                                                        onClick={() =>
                                                                                            setOpenPriorityTaskId(
                                                                                                openPriorityTaskId === task.AccountProjectTaskId
                                                                                                    ? null
                                                                                                    : task.AccountProjectTaskId
                                                                                            )
                                                                                        }
                                                                                        data-tooltip-place="top"
                                                                                        data-tooltip-id="tooltip-Description"
                                                                                        data-tooltip-content={getValueFromResource('Priority', dispatch, t)}
                                                                                    />

                                                                                    <Dropdown
                                                                                        show={openPriorityTaskId === task.AccountProjectTaskId}
                                                                                        onToggle={(isOpen) =>
                                                                                            setOpenPriorityTaskId(
                                                                                                isOpen ? task.AccountProjectTaskId : null
                                                                                            )
                                                                                        }
                                                                                        align="start"
                                                                                    >
                                                                                        <Dropdown.Toggle
                                                                                            as="div"
                                                                                            className="cursor-pointer"
                                                                                        >
                                                                                            <span
                                                                                                className="fs-7"
                                                                                                style={{ color: priorityInfo?.color }}
                                                                                            >
                                                                                                {priorityInfo?.name}
                                                                                            </span>
                                                                                        </Dropdown.Toggle>

                                                                                        <PriorityMenu
                                                                                            prioritiesData={prioritiesData}
                                                                                            onSelectPriority={(priority: any) => {
                                                                                                handlePriorityChange(
                                                                                                    task.AccountProjectTaskId,
                                                                                                    priority
                                                                                                );
                                                                                                setOpenPriorityTaskId(null);
                                                                                            }}
                                                                                            selectedPriority={priorityInfo?.name}
                                                                                        />
                                                                                    </Dropdown>
                                                                                </div>

                                                                            </div>
                                                                            <div className='symbol-group flex-shrink-0'>
                                                                                {task?.TaskTeamMembers != null && parse(`${task?.TaskTeamMembers}`)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        )
                                                    })}
                                                    {provided.placeholder}
                                                </div>
                                            </div>
                                        )}
                                    </Droppable>
                                )
                            })}
                        </div>
                    </DragDropContext>
                </div>
            </div>
        </div>
    )
}

export default UpdatedBoard